import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";


export const useGetExams = (enabled: boolean = true) => {
    const axios = useAxios();
    const {t} = useTranslation();

    const getExams = async () => {
        try {
            const response = await axios.get("/api/exam");
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getExams"));
        }
    }

    return useQuery({queryKey: ["exams"], queryFn: getExams, staleTime: Infinity, enabled})
}